
/* injects from baggage-loader */

'use strict';

export default function (app) {

	app.directive('format', FormatDirective);

	function isValid(val) {
		return angular.isNumber(val) && !isNaN(val);
	}

	function FormatDirective($filter, $log) {
		'ngInject';

		return {
			restrict: 'A',
			link: linkFn,
			require: 'ngModel',
			scope: {
				defaultValue: '=',
				onBlur: '&'
			}
		};

		function linkFn(scope, elem, attrs, ctrl) {
			// if (!ctrl) return;

			// $log.log(ctrl)

			if (attrs.format === 'type-currency') {

				// ngModel.$formatters.push(function(amount) {
				// 	return 
				// });

			} else if (attrs.format === 'currency') {


				// let opts = {
				// 	updateOn: 'blur enter',
				// 	updateOnDefault: false
				// };
				// if (ctrl.$options !== null && ctrl.$options !== undefined)
				// 	opts = ctrl.$options.createChild(opts);

				// ctrl.$options = opts;

				// let filter = $filter('currency');
				// ctrl.$formatters.push(function fromModelToView(value) {
				// 	return filter(value);
				// });

				// ctrl.$parsers.push(function (value) {
				// 	value = value.replace(/[^\d|\-+|.+]/g, '').replace(/\D/g, '');

				// 	let currency = filter(value);
				// 	if (isValid(currency)) {
				// 		ctrl.$setViewValue(filter(currency));
				// 		ctrl.$render();
				// 		return currency;
				// 	}
				// });

				// elem.on('blur', function () {
				// 	if (ctrl.$viewValue === ctrl.$modelValue)
				// 		elem.val(filter(ctrl.$modelValue));
				// });

				// elem.on('focus', function () {
				// 	if (isValid(ctrl.$modelValue)) {
				// 		ctrl.$setViewValue(ctrl.$modelValue);
				// 		ctrl.$render();
				// 	}
				// });

				// ctrl.$validators.currency = function (modelValue) {
				// 	return isValid(modelValue);
				// };





				ctrl.$formatters.unshift(function (a) {
					return $filter(attrs.format)(ctrl.$modelValue, '$', 0)
				});

				elem.bind('propertychange keyup paste blur', function (event) {
					let plainNumber = elem.val().replace(/[^\d|\-+|.+]/g, '').replace(/\D/g, '');
					// $log.log('Value:', plainNumber);
					// $log.log('Default:', scope.defaultValue);
					if (event.type === 'blur') {
						if (!plainNumber || plainNumber < scope.defaultValue) {
							elem.val($filter(attrs.format)(scope.defaultValue, '$', 0));
							scope.onBlur({ amount: scope.defaultValue });
						} else {
							scope.onBlur({ amount: plainNumber });
						}
					} else {
						if (plainNumber) {
							elem.val($filter(attrs.format)(plainNumber, '$', 0));
						}
					}
				});

			} else if (attrs.format === 'currency-cents') {

				elem.bind('propertychange keyup paste blur', function (event) {
					let number = elem.val().replace('$0.', '').replace(/\D/g, '');
					elem.val('$0.' + number || '');
				});

			} else {
				/* do nothing */
			}

		}

	}
}


// WEBPACK FOOTER //
// ./src/app/core/directives/format/format.directive.js